<template>
  <v-layout>
    <v-img
      :src="src"
      :max-width="column.max_width"
      :max-height="column.max_height"
      contain
    ></v-img>
  </v-layout>
</template>

<script>
import config from "../../config";

export default {
  name: "ImageColumn",
  props: ["entity", "column", "value"],
  computed: {
    src() {
      if (!this.value) return "";
      // Костыль
      if (this.value.startsWith("http")) return this.value;
      else {
        const re = /{([\w\d]+)}/g;
        const url = this.column.url_pattern.replace(re, chunk => {
          const param = chunk.slice(1, -1);
          if (param === "filename") return this.value;
          return this.entity[param];
        });
        return config.imagesBaseUrl + url;
      }
    }
  }
};
</script>

<style scoped></style>
